



















import {mixins} from "vue-class-component";
import {CommonMixin} from "../../services/mixin";
import {Component, Emit, Model, Watch} from "vue-property-decorator";

@Component({
  name: "InputTimeCustom"
})
export default class extends mixins(CommonMixin) {
  @Model("change", { type: String }) readonly inputTime!: string;
  @Emit('change')
  onChangeInputTime(val: any) {
    return val;
  }
  hours = '00' as any;
  minutes = '00' as any;

  created() {
    const timeCustom = this.inputTime.split(':');
    this.hours = timeCustom[0] || '';
    this.minutes = timeCustom[1] || '';
  }

  @Watch("inputTime")
  onChangeInput(val: any) {
      const timeCustom = this.inputTime.split(':');
      this.hours = timeCustom[0] || '';
      this.minutes = timeCustom[1] || '';
  }

  onKeyUpHour(evt: any) {
    let val = evt.target.value;
    if (!val) return;
    if (isNaN(val)) val = '00';
    if (val > 23) val = '23';
    this.hours = val;
    const inputTime = `${val ? val : '00'}:${this.minutes ? this.minutes : ''}`
    this.onChangeInputTime(inputTime);
    if (evt.which == 9) return;
    if (val.length >= 2) (this.$refs.inputMinutes as any).focus();
  }

  onKeyUpMinute(evt: any) {
    let val = evt.target.value;
    if (!val) return;
    if (isNaN(val)) val = '00';
    if (val > 59) val = 59;
    this.minutes = val;
    const inputTime = `${this.hours ? this.hours : ''}:${val ? val : '00'}`
    this.onChangeInputTime(inputTime);
  }
}
